import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import Checkbox from './Checkbox';
import { helpIcon } from '../icons';
import ImageButton from './ImageButton';
import './Option.css';
const Option = ({ checked = false, disabled = false, type, onToggle, onHelp, label, helpId }) => {
    const id = useId();
    return _jsxs("div", { id: id, className: `flowOption ${disabled ? 'disabled' : 'enabled'}`, onClick: (ev) => { ev.preventDefault(); if (!disabled)
            onToggle === null || onToggle === void 0 ? void 0 : onToggle(!checked); }, children: [_jsx(Checkbox, { checked: checked, disabled: disabled, onToggle: onToggle, type: type }), _jsx("label", { htmlFor: id, children: label }), onHelp && _jsx(ImageButton, { focusId: helpId !== null && helpId !== void 0 ? helpId : id, icon: helpIcon, onClick: (_keyAction) => onHelp(), size: 'medium', type: 'minor', disabled: disabled })] });
};
export default Option;
